import React from 'react';
import { Typography } from 'antd';
import List from './List';

export default function Reviews(): React.ReactNode {
  return (
    <div>
      <Typography.Title level={4}>
        Отзывы
      </Typography.Title>
      <List />
    </div>
  );
}
